import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type MarginState = {
  traderAccountId?: string;
  tradeCurrency?: string;
  setTraderAccountId: (traderAccountId: string) => void;
  setTradeCurrency: (tradeCurrency: string) => void;
  reset: () => void;
};

const useSwyftxMarginStore = create<MarginState>()(
  persist(
    (set) => ({
      setTraderAccountId: (traderAccountId: string) => {
        set({ traderAccountId });
      },
      setTradeCurrency: (tradeCurrency: string) => {
        set({ tradeCurrency });
      },
      reset: () => {
        set({ traderAccountId: undefined, tradeCurrency: 'BTC' });
      },
    }),
    {
      name: 'derivatives-store',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export { useSwyftxMarginStore };
